import styles from './SpinnerIcon.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function SpinnerIcon({className}) {
  const classNameArray = className?.split(' ') || [];
	return (
    <svg width="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={cx(['spinner-icon', ...classNameArray])}><path d="M14 1v4a1 1 0 0 1-2 0V1a1 1 0 0 1 2 0Zm4.656 7.344a1 1 0 0 0 .708-.294l2.828-2.828a1 1 0 0 0-1.415-1.415l-2.827 2.83a1 1 0 0 0 .706 1.707ZM25 12h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm-5.636 5.95a1 1 0 0 0-1.414 1.414l2.828 2.828a1 1 0 1 0 1.415-1.415l-2.83-2.827ZM13 20a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1Zm-6.364-2.05-2.829 2.828a1 1 0 1 0 1.416 1.415l2.827-2.83a1 1 0 0 0-1.414-1.413ZM6 13a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1Zm-.777-9.192a1 1 0 1 0-1.415 1.415L6.636 8.05A1 1 0 0 0 8.05 6.636L5.222 3.807Z" fill="#202020"/></svg>
	);
}